const steps = [
  {
    number: '01',
    icon: '✦',
    title: 'Understand the learner',
    description:
      'We begin with the child’s age, interests and learning goals to identify the most suitable program.',
  },
  {
    number: '02',
    icon: '◌',
    title: 'Learn live with a mentor',
    description:
      'Interactive online sessions combine clear instruction, guided practice and personal attention.',
  },
  {
    number: '03',
    icon: '↗',
    title: 'Practice and progress',
    description:
      'Regular practice builds confidence, strengthens skills and helps learning become a positive habit.',
  },
];

function LearningJourney() {
  return (
    <section className="journey" aria-labelledby="journey-title">
      <div className="container">
        <div className="journey-heading">
          <div>
            <span className="eyebrow">A simple learning journey</span>
            <h2 id="journey-title">From curiosity to confidence.</h2>
          </div>
          <p>
            A clear, supportive approach that keeps children engaged and helps
            families choose the right path.
          </p>
        </div>

        <div className="journey-grid">
          {steps.map((step) => (
            <article className="journey-card" key={step.number}>
              <span className="journey-number">{step.number}</span>
              <span className="journey-icon" aria-hidden="true">{step.icon}</span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LearningJourney;
